import { NgModule } from '@angular/core';
import { CurrencyFormatPipe } from './currency-format.pipe';

/**
 * Módulo que expone el pipe CurrencyFormatPipe
 * para su uso en toda la aplicación.
 */
@NgModule({
    declarations: [CurrencyFormatPipe],
    exports: [CurrencyFormatPipe]
})
export class CurrencyPipesModule { }
